import { createSlice } from "@reduxjs/toolkit";

const initalState = {
  selectedType: null,
  selectedTeritory: null,
  selectedIndustry: null,
  selectedStatus: null,
  syncEnabled: null,
  selectedWebsite: null,
  page: 0,
  financeList: [],
};

const websiteActionSlice = createSlice({
  name: "websiteAction",
  initialState: initalState,
  reducers: {
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
    },
    setSelectedTeritory: (state, action) => {
      state.selectedTeritory = action.payload;
    },
    setSelectedIndustry: (state, action) => {
      state.selectedIndustry = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSyncEnabled: (state, action) => {
      state.syncEnabled = action.payload;
    },
    setSelectedWebsite: (state, action) => {
      state.selectedWebsite = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setFinanceList: (state, action) => {
      state.financeList = action.payload;
    },
  },
});

export const {
  setSelectedType,
  setSelectedTeritory,
  setSelectedIndustry,
  setSelectedStatus,
  setSyncEnabled,
  setSelectedWebsite,
  setPage,
  setFinanceList,
} = websiteActionSlice.actions;
export default websiteActionSlice.reducer;
